































































import {Component, Vue, Watch} from 'vue-property-decorator'
import usersApi from '@/api/users'
import {
    UserCreateDto
} from "@/global";
import * as enums from "@/global-enum";
import Helpers from "@/helpers";

@Component({
    components: {
    }
})
export default class ResetPassword extends Vue {
    isLoading = true;
    isButtonsDisabled = false;

    newPassword = "";
    confirmNewPassword = "";

    mounted() {
        // password reset key is empty
        if (!this.$helpers.isNotEmpty(this.$route.params.key)) {
            this.$router.push({ name: 'login' });
            return;
        }

        this.isLoading = false;
    }

    // computed
    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    @Watch("newPassword")
    onNewPasswordUpdate(val: string, oldVal: string) {
        if (val === oldVal) return;
        this.newPassword = this.$appUtils.specialUserPasswordTrim(this.newPassword);
    }

    // methods
    validateState(ref: string) {
        return this.$appUtils.vvValidateState(this, ref);
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    async changePassword() {
        this.isButtonsDisabled = true;

        let isValid = await this.$validator.validateAll();

        if (isValid) {
            usersApi.changePasswordByKey(this.$route.params.key, this.newPassword, (data) => {
                if (data.success) {
                    this.$router.push({ name: 'login' })
                } else {
                    this.showError();
                }
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage);
            });
        } else {
            this.isButtonsDisabled = false;
        }
    }
}
